import React from 'react'
import styled from 'styled-components'
import { mediaPc } from '../../../lib/MediaQuery'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.13vw;
  padding: 3.2vw 4.8vw;
  background-color: ${(props): string => props.theme.backgroundColors.primary};

  .banner-item {
    display: flex;
    align-items: center;
    gap: 2.13vw;

    .badge {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 5.33vw;
      height: 5.33vw;
      border-radius: 50%;
      background-color: ${(props): string => props.theme.textColors.white};
      color: ${(props): string => props.theme.textColors.black};
      font-size: 3.2vw;
      font-weight: 700;
    }

    .text {
      color: ${(props): string => props.theme.textColors.black};

      .headline {
        font-size: 3.47vw;
        font-weight: 700;
        letter-spacing: 0.05em;
      }

      .supplement {
        font-size: 2.67vw;
        letter-spacing: 0.03em;
      }
    }
  }

  ${mediaPc`
    flex-direction: row;
    justify-content: center;
    gap: 48px;
    padding: 14px 20px;

    .banner-item {
      gap: 10px;

      .badge {
        width: 24px;
        height: 24px;
        font-size: 14px;
      }

      .text {
        .headline {
          font-size: 15px;
        }

        .supplement {
          font-size: 12px;
        }
      }
    }
  `}
`

export const HomeTopBanner: React.FC = () => {
  return (
    <Wrapper>
      <div className="banner-item">
        <span className="badge" aria-hidden="true">✓</span>
        <p className="text">
          <span className="headline">Paidy後払いOK(コンビニ/口座振替/銀行振込)</span>
          <br />
          <span className="supplement">カードがなくても購入できます</span>
        </p>
      </div>
      <div className="banner-item">
        <span className="badge" aria-hidden="true">✓</span>
        <p className="text">
          <span className="headline">写真・動画は3日以内のお届けが目安</span>
          <br />
          <span className="supplement">クリエイターに期限内の納品をお願いしています</span>
        </p>
      </div>
    </Wrapper>
  )
}
